"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmojiActivityIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.677 16.738A5.97 5.97 0 0 1 12 18a5.97 5.97 0 0 1-3.677-1.262 6.33 6.33 0 0 0 1.982-4.589 6.33 6.33 0 0 0-2.157-4.746A5.97 5.97 0 0 1 12 6c1.465 0 2.808.528 3.851 1.403a6.33 6.33 0 0 0-2.156 4.746c0 1.751.736 3.41 1.982 4.589m1.354-1.472c.613-.94.969-2.063.969-3.266 0-1.124-.31-2.176-.85-3.076a4.32 4.32 0 0 0-1.455 3.225c0 1.187.495 2.313 1.336 3.117m-10.062 0A5.96 5.96 0 0 1 6 12c0-1.124.31-2.176.85-3.076a4.32 4.32 0 0 1 1.455 3.225 4.32 4.32 0 0 1-1.336 3.117M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16"/></svg>`
}, props));
EmojiActivityIcon.displayName = 'EmojiActivityIcon';
var _default = exports.default = EmojiActivityIcon;